'use client';

import { ReviewCGType } from '@/types/graphql/root';
import isString from 'lodash/isString';
import Image from 'next/image';
import Stars from './stars';
import dayjs from 'dayjs';
import PoweredByGoogle from '@/images/powered_by_google.png';

export default function GoogleReview({ reviews }: { reviews: ReviewCGType[] }) {
  return (
    <div>
      <div className='pt-24pxr px-20pxr'>
        <p className='text-gray-800 heading-16-b'>구글 리뷰</p>
      </div>
      {reviews.map((review, idx) => (
        <div key={idx}>
          <div className='flex flex-col border-b border-gray-100 p-20pxr gap-12pxr'>
            <div className='flex flex-row gap-8pxr'>
              {isString(review.profilePhotoUrl) && (
                // eslint-disable-next-line @next/next/no-img-element
                <img className='rounded-full w-40pxr h-40pxr' src={review.profilePhotoUrl} alt='profile' />
              )}
              <div className='flex flex-col gap-6pxr'>
                <div className='flex'>
                  {isString(review.authorName) && <p className='text-gray-800 sub-heading-14-m'>{review.authorName}</p>}
                </div>
                <div className='flex flex-row items-center gap-8pxr'>
                  {review.rating && <Stars rating={review.rating} type='google' />}
                  {review.createdAt && (
                    <p className='text-gray-400 body-14-r'>{dayjs(new Date(review.createdAt)).format('YYYY.MM.DD')}</p>
                  )}
                </div>
              </div>
            </div>

            {isString(review.text) && <p className='text-gray-800 whitespace-pre-wrap body-14-r'>{review.text}</p>}
          </div>
        </div>
      ))}
      <div className='flex justify-end bg-white p-16pxr h-50pxr'>
        {/* <img className='w-144pxr' src={PoweredByGoogleImage} /> */}
        <Image src={PoweredByGoogle} alt='Powered by Google' width={144} height={18} className='w-144pxr h-18pxr' />
      </div>
    </div>
  );
}
